export const GET_ITEMS_REQUEST = "GET_ITEMS_REQUEST";
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS";
export const GET_ITEMS_FAIL = "GET_ITEMS_FAIL";

export const GET_ITEM_MOVE_REQUEST = "GET_ITEM_MOVE_REQUEST";
export const GET_ITEM_MOVE_SUCCESS = "GET_ITEM_MOVE_SUCCESS";
export const GET_ITEM_MOVE_FAIL = "GET_ITEM_MOVE_FAIL";
